export default {
  init() {
    // JavaScript to be fired on all pages
    // Shrinking header
    $(window).scroll(function() {
        if ($(document).scrollTop() > 50) {
          $('.site-header').addClass('shrink');
        } else {
          $('.site-header').removeClass('shrink');
        }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */
        
        $(document).ready(function () {


           $('.search-btn').click(function(){
               $('.search-area').fadeIn(); 
               $('.close-btn').fadeIn();              
           });
           $('.close-btn').click(function(){
               $('.search-area').fadeOut(); 
               $('.search-area').close();            
           });


            /**
             * navigation.js
             *
             * Handles toggling the navigation menu for small screens and enables tab
             * support for dropdown menus.
             */
            ( function() {
              var container, button, menu, links, subMenus;

              container = document.getElementById( 'site-navigation' );
              if ( ! container ) {
                return;
              }

              button = container.getElementsByTagName( 'button' )[0];
              if ( 'undefined' === typeof button ) {
                return;
              }

              menu = container.getElementsByTagName( 'ul' )[0];

              // Hide menu toggle button if menu is empty and return early.
              if ( 'undefined' === typeof menu ) {
                button.style.display = 'none';
                return;
              }

              menu.setAttribute( 'aria-expanded', 'false' );
              if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
                menu.className += ' nav-menu';
              }

              button.onclick = function() {
                if ( -1 !== container.className.indexOf( 'toggled' ) ) {
                  container.className = container.className.replace( ' toggled', '' );
                  button.setAttribute( 'aria-expanded', 'false' );
                  menu.setAttribute( 'aria-expanded', 'false' );
                } else {
                  container.className += ' toggled';
                  button.setAttribute( 'aria-expanded', 'true' );
                  menu.setAttribute( 'aria-expanded', 'true' );
                }
              };

              // Get all the link elements within the menu.
              links    = menu.getElementsByTagName( 'a' );
              subMenus = menu.getElementsByTagName( 'ul' );

              // Set menu items with submenus to aria-haspopup="true".
              for ( var i = 0, len = subMenus.length; i < len; i++ ) {
                subMenus[i].parentNode.setAttribute( 'aria-haspopup', 'true' );
              }

              // Each time a menu link is focused or blurred, toggle focus.
              for ( i = 0, len = links.length; i < len; i++ ) {
                links[i].addEventListener( 'focus', toggleFocus, true );
                links[i].addEventListener( 'blur', toggleFocus, true );
              }

              /**
               * Sets or removes .focus class on an element.
               */
              function toggleFocus() {
                var self = this;

                // Move up through the ancestors of the current link until we hit .nav-menu.
                while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

                  // On li elements toggle the class .focus.
                  if ( 'li' === self.tagName.toLowerCase() ) {
                    if ( -1 !== self.className.indexOf( 'focus' ) ) {
                      self.className = self.className.replace( ' focus', '' );
                    } else {
                      self.className += ' focus';
                    }
                  }

                  self = self.parentElement;
                }
              }
            } )();

        });


        $('.hamburger').click( function() {
          $('.hamburger').toggleClass('is-active');
          $('.mobile-navigation').toggleClass('is-active');
          $('body').toggleClass("bodyfixed");
        });

        $('.hamburger.is-active').click( function() {
          $('.mobile-navigation').toggleClass('is-active');
          $('.hamburger').toggleClass('is-active');
          $('body').toggleClass("bodyfixed");
        });

        if ($(window).width() > 992) {
          $('.dropdown > a').click(function(){
              location.href = this.href;
          });
        };


        $(document).ready(function(){
          $('.sl-panels .sl-card .card-body').matchHeight();
        });
        $(window).resize(function() {
          $('.sl-panels .sl-card .card-body').matchHeight();
        });
        



        new WOW().init(); 

        $(".main").fitVids();

        //$(window).load(function(){
        //  $('#popup-box').modal('show');
        //});





        var cookieName = 'lafCookie'; // The cookie name
        var cookieLifetime = 10; // Cookie expiry in days
       
        /**
         * Set a cookie
         * @param cname - cookie name
         * @param cvalue - cookie value
         * @param exdays - expiry in days
         */
        var _setCookie = function (cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires=" + d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        };
       
        /**
         * Get a cookie
         * @param cname - cookie name
         * @returns string
         */
        var _getCookie = function (cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        };
       
        /**
         * Should the cookie popup be shown?
         */
        var _shouldShowPopup = function () {
          if (_getCookie(cookieName)) {
            return false;
          } else {
            return true;
          }
        };
       
        // Show the cookie popup on load if not previously accepted
        if (_shouldShowPopup()) {
          $('#popup-box').modal('show');
        }
       
        // Modal dismiss btn - consent
        $('#popup-box .close').on('click', function () {
          _setCookie(cookieName, 1, cookieLifetime);
        });


    /* eslint-enable */


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js